import {
  BillSwitchProductIntroScreen,
  BillSwitchProductIntroScreenResultTypenames,
  Query,
} from '@varo/graphql-schema-types';
import FetchBillSwitchSweepstakesIntroScreen from 'services/graphql/queries/billSwitch/FetchBillSwitchSweepstakesIntroScreen';
import { useFormattedGQLErrors } from 'shared/hooks/errorFormatters/useFormattedGQLErrors';
import { Maybe } from 'shared/utils/types';
import { useQuery } from 'urql';

const useFetchBillSwitchProductIntroScreen = () => {
  const [{ data, error, fetching }, refetch] = useQuery<Query>({
    query: FetchBillSwitchSweepstakesIntroScreen,
    requestPolicy: 'cache-and-network',
  });

  const { billSwitchSweepstakesIntroScreen } = data ?? {};

  const formattedError = useFormattedGQLErrors({
    combinedError: error,
    errorLike: billSwitchSweepstakesIntroScreen,
  });

  let result: Maybe<BillSwitchProductIntroScreen> = null;
  if (
    billSwitchSweepstakesIntroScreen?.__typename ===
    BillSwitchProductIntroScreenResultTypenames.BillSwitchProductIntroScreen
  ) {
    result = billSwitchSweepstakesIntroScreen;
  }

  return {
    result,
    error: formattedError,
    fetching,
    refetch: () => refetch({ requestPolicy: 'network-only' }),
  };
};

export default useFetchBillSwitchProductIntroScreen;
